import { Clock, MapPin } from "lucide-react";

/**
 * Compact badge shown in the admin header summarising the user's previous login.
 * Renders nothing on first-ever login (no previous data).
 */
function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso.replace(" ", "T") + "Z").getTime();
  const diffMs = Date.now() - then;
  if (Number.isNaN(diffMs)) return iso;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return "gerade eben";
  if (min < 60) return `vor ${min} Min`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `vor ${hours} Std`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `vor ${days} Tg`;
  return new Date(iso.replace(" ", "T") + "Z").toLocaleDateString("de-DE");
}

function maskIp(ip) {
  if (!ip) return "—";
  // IPv4: drop last octet; IPv6: drop last segment
  if (ip.includes(".")) {
    const parts = ip.split(".");
    return parts.slice(0, 3).join(".") + ".…";
  }
  if (ip.includes(":")) {
    const parts = ip.split(":");
    return parts.slice(0, 3).join(":") + ":…";
  }
  return ip;
}

export default function LastActivityBadge({ at, ip }) {
  if (!at) return null;
  const time = relativeTime(at);
  const ipMasked = maskIp(ip);
  const full = at && ip
    ? `Zuletzt eingeloggt am ${new Date(at.replace(" ", "T") + "Z").toLocaleString("de-DE")} von ${ip}`
    : "Letzte Anmeldung";

  return (
    <div
      data-testid="last-activity-badge"
      title={full}
      className="hidden md:flex items-center gap-2 text-[11px] text-[#8899AA] bg-[#12202f] border border-[#3A4F60]/40 rounded-md px-2.5 py-1.5"
    >
      <Clock className="w-3 h-3 text-[#C5993A]" />
      <span className="whitespace-nowrap">Zuletzt <span className="text-white">{time}</span></span>
      <span className="text-[#3A4F60]">·</span>
      <MapPin className="w-3 h-3 text-[#C5993A]" />
      <span className="whitespace-nowrap font-mono">{ipMasked}</span>
    </div>
  );
}
